import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { renderRLHeader } from './Helpers';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsCervicalMyelopathyCPR extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_CervicalMyelopathyCPR' name='Cervical Myelopathy CPR' visible={false} flagged={this.props.flagged}>
                    {renderRLHeader()}
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Cervical Myelopathy CPR' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYGAITDEV === 28) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYHOFFMANNSR === 1 ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYHOFFMANNSL === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYINVSUPR === 1 ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYINVSUPL === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYBABINSKIR === 1 ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYBABINSKIL === 1) {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCMYAGEGT45 === true) {
        flagCount++;
    }


    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'CervicalMyelopathyCPR'),
        flagged: flagCount >= 1 ? true : false
    };
}

const connectedSpecTestsCervicalMyelopathyCPR = connect(mapStateToProps)(SpecTestsCervicalMyelopathyCPR);
export { connectedSpecTestsCervicalMyelopathyCPR as SpecTestsCervicalMyelopathyCPR };



